import {
  ContentSections,
  getImageReference,
  getItemReference,
} from "@tiicker/util/lib/contentful/helpers";
import {
  BrandDetailDocument,
  InsightDocument,
  PageSection,
  PerkDocument,
  PinnedNews,
  BrandInvestment,
} from "@tiicker/util/lib/contentful/types";
import { GetHasActivePerksForBrand } from "$gql/queries/general/GetHasActivePerksForBrand.gen";
import { useQueryBundle } from "source/hooks";
import React, {
  useRef,
  useEffect,
  useState,
  Suspense,
  lazy,
  MutableRefObject,
} from "react";
import { TriggerUpdate } from "components/TriggerUpdate";
import { useZaiusEvents, ZaiusEventType } from "source/zaius/helper";
import { Asset, Entry, EntryCollection } from "contentful";
import { useFetchUser } from "source/hooks";
import { useRecommendations } from "components/RecommendationContext/RecommendationContext";
import { EntityType, IexCompany, IexQuote } from "$gql/types.gen";
import MetaTags from "components/MetaTags/MetaTags";
import MetaImage from "components/MetaTags/MetaImage";
import LoginModal from "components/LoginModal/LoginModal";
import { useRouter } from "next/router";
import BrandHeader from "components/BrandPage/BrandHeader/BrandHeader";
import BrandStickyNav from "components/BrandPage/StickyNav/BrandStickyNav";
import NavigationBar from "components/Global/Navigation/NavigationBar/NavigationBar";
import FooterV2 from "components/FooterV2/FooterV2";
import StockPerformance from "components/BrandPage/StockPerformance/StockPerformance";
import { AdCampaign } from "components/AdCampaign/AdCampaign";
import HomeHowItWorks from "components/Home/HomeHowItWorks/HomeHowItWorks";
import styles from "./BrandPageUI.module.scss";
import StartEarningPerksCTA from "components/CallToActions/StartEarningPerks/StartEarningPerksCTA";
import VoteForPerks from "components/BrandPage/VoteForPerks/VoteForPerks";
import { GetUserBrandInterest } from "$gql/queries/general/GetUserBrandInterest.gen";
import { LifestyleQuestions } from "components/LifestyleQuestionsV2/LifestyleQuestions";
import BrandOverview from "components/BrandOverview/BrandOverview";
import { default as NewsSidebar } from "components/News/Sidebar/Sidebar";
import BrandInsights from "components/Insights/BrandInsights";
import BrandNewsItems from "components/News/BrandNewsItems/BrandNewsItems";
import { compact } from "lodash";
import isFuture from "date-fns/isFuture";
import PerksSection from "components/BrandPage/PerksSection/PerksSection";
import { GetUserHoldingsForSymbols } from "$gql/queries/general/GetUserHoldingsForSymbols.gen";
import { useQuery } from "@apollo/client";
import { GetStoreAutoLoginToken } from "$gql/queries/general/GetStoreAutoLoginToken.gen";
import TradeModal from "components/TradeModal/TradeModal";
import ColorWrapper from "components/Home/ColorWrapper/ColorWrapper";
import LoadingBlock from "components/Loading/LoadingBlock";
import { Media } from "components/Media/media";
import NavbarLayout from "components/Layout/NavbarLayout";
import Four04 from "components/404/404";
import {
  triggerSubnavEvent,
  triggerTradeButtonEvent,
} from "source/analytics-events";
import TrendingPerks from "../TrendingPerks/TrendingPerks";
import { GetMonthsPopularPerks } from "$gql/queries/general/GetMonthsPopularPerks.gen";
import BrandFiles from "../BrandFIles/BrandFiles";
import StartEarningPerksMadi from "components/StartEarningPerksMadi/StartEarningPerksMadi";
import NoSSR from "components/NoSSR/NoSSR";
import Investment from "components/BrandPage/BrandInvestment/Investment";
//import { GetUserHoldingTransactions } from "$gql/queries/general/GetUserHoldingTransactions.gen"; //TODO: Fix for TiiCKER-196

const InsightsSidebar = lazy(
  () => import("components/Insights/Sidebar/Sidebar")
);

export enum TabKey {
  Perks = "Perks",
  HowItWorks = "How it works",
  About = "About",
  Insights = "Insights",
  News = "News",
  Performance = "Performance",
  ShareholderStore = "Shareholder Store",
}

type Props = {
  symbol?: string;
  brandDetail?: EntryCollection<BrandDetailDocument>;
  iexCompany: IexCompany | null;
  joinNowCTA?: Entry<PageSection>;
  howItWorks?: Entry<PageSection>;
  tiickerPerksCTA?: Entry<PageSection>;
  redirected?: boolean;
  contentSections?: ContentSections;
  pageSectionIncludes?: any;
  brandPerks?: EntryCollection<PerkDocument>;
  owningPerks?: EntryCollection<PerkDocument>;
  brandInsights?: EntryCollection<InsightDocument>;
  brandInvestment?: Entry<BrandInvestment>;
  quote?: IexQuote;
};

const BrandDetailUI = (props: Props) => {
  //console log out al the props separately
  // Keeping these logs in the code so if we need to see any of the countless properties we can easily find it.
  // console.log("BrandDetailUI props symbol", props.symbol);
  // console.log("BrandDetailUI props brandDetail", props.brandDetail);
  // console.log("BrandDetailUI props iexCompany", props.iexCompany);
  // console.log("BrandDetailUI props joinNowCTA", props.joinNowCTA);
  // console.log("BrandDetailUI props howItWorks", props.howItWorks);
  // console.log("BrandDetailUI props tiickerPerksCTA", props.tiickerPerksCTA);
  // console.log("BrandDetailUI props redirected", props.redirected);
  // console.log("BrandDetailUI props contentSections", props.contentSections);
  // console.log(
  //   "BrandDetailUI props pageSectionIncludes",
  //   props.pageSectionIncludes
  // );
  // console.log("BrandDetailUI props brandPerks", props.brandPerks);
  // console.log("BrandDetailUI props owningPerks", props.owningPerks);
  // console.log("BrandDetailUI props brandInsights", props.brandInsights);
  console.log("BrandDetailUI props  Brand Investment", props.brandInvestment);

  const { user, loading: userIsLoading } = useFetchUser();

  const [activeTab, setActiveTab] = useState(TabKey.Perks);
  const [clickedTab, setClickedTab] = useState<TabKey | undefined>(undefined);
  const [clickTimeoutToken, setClickTimeoutToken] = useState<
    NodeJS.Timeout | undefined
  >();
  const aboutSectionRef = useRef<HTMLDivElement>(null);

  const scrollToAbout = () => {
    if (aboutSectionRef.current) {
      aboutSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (clickedTab !== activeTab && clickedTab !== undefined) {
      setActiveTab(clickedTab);
    }

    if (clickTimeoutToken) {
      clearTimeout(clickTimeoutToken);
    }

    const token = setTimeout(() => setClickedTab(undefined), 500);
    setClickTimeoutToken(token);
  }, [clickedTab, activeTab]);

  const setActiveTabThrottledOnClick = (key: TabKey, isClicked?: boolean) => {
    if (isClicked) {
      setClickedTab(key);
      if (props.symbol) {
        triggerSubnavEvent(key, props.symbol);
      }
    } else {
      setActiveTab(key);
    }
  };

  const [insightSidebarOpen, setInsightSidebarOpen] = useState<boolean>(false);
  const [newsSidebarOpen, setNewsSidebarOpen] = useState<boolean>(false);

  const userHolding = useQueryBundle(GetUserHoldingsForSymbols, {
    variables: {
      symbols: [props.symbol || ""],
    },
  });
  const popularPerks = useQueryBundle(GetMonthsPopularPerks);
  // TODO: Fix for TiiCKER-196
  /*const [buyDateTransaction, setBuyDateTransaction] = useState<null | Date>(
    null
  );
  const [sellDateTransaction, setSellDateTransaction] = useState<null | Date>(
    null
  );

  const [buyDateTransactionID, setBuyDateTransactionID] = useState(0);
  const [sellDateTransactionID, setSellDateTransactionID] = useState(0);

  const userHoldingTransactions = useQueryBundle(GetUserHoldingTransactions, {
    variables: { userId: user?.id, tickerSymbol: props.symbol || "" },
  });*/

  const router = useRouter();

  const { source } = router.query;

  const recommendations = useRecommendations();

  useEffect(() => {
    if (props.symbol) {
      recommendations.addView(props.symbol.toUpperCase(), EntityType.Company);
    }
  }, [props.symbol]);

  useEffect(() => {
    if (props.redirected && props.symbol) {
      recommendations.addRedirect(
        props.symbol.toUpperCase(),
        EntityType.Company
      );
    }
  }, [props.redirected]);

  const tabsEl = useRef(null);
  const heroImageEl = useRef(null);

  const scrollToRef = (ref: React.RefObject<any>) => {
    let y: number = ref.current.offsetTop;
    if (heroImageEl !== null) {
      // Find the height of the heroImage and add it to the tab offset
      y =
        (heroImageEl as React.RefObject<any>).current.getBoundingClientRect()
          .height + ref.current.offsetTop;
    }
    if (typeof window !== "undefined") {
      window.scrollTo(0, y);
    }
  };

  const [hasScrolledToPerks, setHasScrolledToPerks] = useState(false);
  useEffect(() => {
    if (source === "benzinga-perks" && !hasScrolledToPerks) {
      scrollToRef(tabsEl);
      setHasScrolledToPerks(true);
    }
  }, [source]);

  const perkQuery = useQueryBundle(GetHasActivePerksForBrand, {
    variables: { tickerSymbol: props.symbol },
  });

  const interestQuery = useQueryBundle(GetUserBrandInterest, {
    variables: { userId: user?.id || 0, tickerSymbol: props.symbol },
  });

  useZaiusEvents(
    [
      {
        type: ZaiusEventType.ProductEvent,
        productId: props.symbol || "",
      },
    ],
    () => perkQuery.state === "DONE"
  );

  const hasPerks =
    props.brandPerks &&
    props.owningPerks &&
    (props.brandPerks.items.length !== 0 ||
      props.owningPerks.items.length !== 0);

  const brand =
    (props.brandDetail?.items.length || 0) > 0
      ? props.brandDetail?.items[0]?.fields
      : undefined;

  const stockDesc = `${props.iexCompany?.companyName} (Tii:${props.symbol}) | Own stock? Get perks. The companies you own want to reward you. TiiCKER makes it easy to discover shareholder perks you may qualify for based on your individual share ownership.`;

  const metaTitle = brand
    ? brand.metaTitleOverride ||
      `${brand.brandName} (Tii:${brand.tickerSymbol})`
    : `${props.iexCompany?.companyName} (Tii:${props.symbol})`;
  const metaDescription = brand
    ? brand.metaDescriptionOverride ||
      brand.description?.split(".").slice(0, 2).join(". ") ||
      stockDesc
    : stockDesc;
  const metaImage = brand
    ? getImageReference(brand.metaImage, props.brandDetail?.includes)
    : undefined;

  const brandPinnedNews = brand?.pinnedNews || [];
  const extractedPinnedNews = compact(
    brandPinnedNews.map((ref) =>
      getItemReference<PinnedNews>(ref, props.brandDetail?.includes)
    )
  ).filter((pinnedNews) =>
    isFuture(new Date(pinnedNews.fields.expirationDate))
  );

  ///////////////////////////
  // Company Store
  ///////////////////////////
  const [showNoUserModal, setShowNoUserModal] = useState(false);

  const tokenQuery = useQuery<
    GetStoreAutoLoginToken.Query,
    GetStoreAutoLoginToken.Variables
  >(GetStoreAutoLoginToken.Document, {
    variables: { tickerSymbolOrSubdomain: props.symbol || "" },
    skip: true,
  });

  const onCompanyStoreClick = async () => {
    if (userIsLoading) {
      return;
    }

    if (!user) {
      setShowNoUserModal(true);
      return;
    }

    // triggerStoreTabEvent(brand.tickerSymbol);

    const tokenResponse = await tokenQuery.refetch();

    if (
      !tokenResponse.data?.getStoreAutoLoginToken?.token ||
      !tokenResponse.data?.getStoreAutoLoginToken.storeUrl
    ) {
      console.error("There was a problem accessing the company store.");
      return;
    }

    window.open(
      `${tokenResponse.data.getStoreAutoLoginToken.storeUrl}?auto=${tokenResponse.data.getStoreAutoLoginToken.token}`,
      "_blank"
    );
  };

  const [showTradeModal, setShowTradeModal] = useState<boolean>(false);

  if (router.isFallback) {
    console.log("LOADING BLOCK HERE YO");
    return <LoadingBlock />;
  }

  const companyNotFound = props.iexCompany === null && !props.brandDetail;

  const scrollToPerks = () => {
    const perksElement = document.querySelector("#Perks");
    if (perksElement) {
      perksElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  if (companyNotFound || props.symbol === "" || props.symbol === undefined) {
    return (
      <NavbarLayout>
        <Four04 />
        {props.joinNowCTA && (
          <StartEarningPerksMadi
            page={props.joinNowCTA}
            includes={props.contentSections?.includes}
          />
        )}
      </NavbarLayout>
    );
  }

  ///////////////////////////
  // Component
  ///////////////////////////
  return (
    <>
      <MetaTags title={metaTitle} description={metaDescription} />

      {metaImage && (
        <MetaImage
          image={metaImage.fields.file.url}
          imageAlt={metaDescription}
        />
      )}

      <div>
        {props.symbol && brand && brand.brandName && (
          <TradeModal
            tickerSymbol={props.symbol}
            companyName={brand.brandName}
            isShowing={showTradeModal}
            setIsShowing={setShowTradeModal}
            // preSelectedAccountId={instutitonAccountIdNumeric}
            iexSymbol={brand.iexSymbol}
            baseUrl={`/brand/${props.symbol}`}
          />
        )}

        <LoginModal
          show={showNoUserModal}
          showModal={setShowNoUserModal}
          description={`To visit the ${
            brand ? brand.brandName : `Tii:${props.symbol}`
          } company store you must have a free account.`}
        ></LoginModal>

        <NavigationBar />
        <TriggerUpdate />

        <ColorWrapper>
          <BrandHeader
            includes={props.brandDetail?.includes}
            brandDetailFields={brand}
            logoAssetId={brand ? brand.companyLogoDark?.sys.id : undefined}
            heroAssetId={brand ? brand.heroImage?.sys.id : undefined}
            hasPerks={hasPerks}
            partner={brand ? brand.partner : false}
            brandName={
              brand ? brand.brandName : props.iexCompany?.companyName ?? ""
            }
            tickerSymbol={props.symbol}
            description={
              brand
                ? brand.headerDescription ?? brand.description
                : props.iexCompany?.description ?? ""
            }
            quoteInfo={
              brand && !brand.isNonPublicCompany ? props.quote : undefined
            }
            iexSymbol={brand ? brand.iexSymbol : ""}
            currentUserHoldingCount={
              userHolding.state === "DONE"
                ? userHolding.data.getUserHoldingsForSymbols.quantity
                : 0
            }
            openTradeModal={() => {
              if (props.symbol) {
                triggerTradeButtonEvent(props.symbol);
              }
              setShowTradeModal(true);
            }}
            scrollToAbout={scrollToAbout}
            brandInvestment={props.brandInvestment}
          />
        </ColorWrapper>
        <BrandStickyNav
          onChange={(key, clicked) =>
            setActiveTabThrottledOnClick(key, clicked)
          }
          activeTab={clickedTab || activeTab}
          activeStore={brand?.activateStore}
          companyStoreClick={onCompanyStoreClick}
        />

        {props.brandInvestment && (
          <Investment
            brandInvestment={props.brandInvestment}
            onClose={scrollToPerks}
            brandName={brand?.brandName ?? ""}
          />
        )}

        <div id="Perks" data-scroll-anchor>
          {!hasPerks && (
            <>
              <VoteForPerks
                brandName={
                  brand ? brand.brandName : props.iexCompany?.companyName ?? ""
                }
                ticker={props.symbol}
                userInterestedInPerks={
                  interestQuery.state === "DONE"
                    ? !!interestQuery.data.getUserBrandInterest
                    : false
                }
                tiickerPerksQualified={
                  props.tiickerPerksCTA?.fields.description
                }
                tiickerPerksSignedOut={
                  props.tiickerPerksCTA?.fields.displayTitle
                }
                perkOverrideMediaUrl={
                  getImageReference(
                    brand?.perkOverrideMedia,
                    props.brandDetail?.includes
                  )?.fields.file.url
                }
                perkVoteOverrideText={brand?.perkVoteOverrideText}
                perkVoteDisclaimerText={brand?.perkVoteDisclaimerText}
              />

              {popularPerks.state === "DONE" && (
                <TrendingPerks
                  perkIds={popularPerks.data.getMonthsPopularPerks}
                />
              )}
            </>
          )}

          {hasPerks && props.brandPerks && props.owningPerks && (
            <PerksSection
              tickerSymbol={props.symbol}
              brandPerks={props.brandPerks}
              owningPerks={props.owningPerks}
              currentUserHoldingCount={
                userHolding.state === "DONE"
                  ? userHolding.data.getUserHoldingsForSymbols.quantity
                  : 0
              }
              currentPrice={props.iexCompany?.quote?.latestPrice ?? 0}
              brand={brand}
              user={user}
              /*buyDate={ //TODO: Fix for TiiCKER-196
                userHoldingTransactions.state === "DONE"
                  ? new Date(
                      userHoldingTransactions.data.getUserHoldingTransactions
                        .filter(
                          (el) => el.transactionType === "buy" && el.id > 0
                        )
                        .map((el) => el.date)[0]
                    )
                  : new Date()
              }
              sellDate={
                userHoldingTransactions.state === "DONE"
                  ? new Date(
                      userHoldingTransactions.data.getUserHoldingTransactions
                        .filter(
                          (el) => el.transactionType === "sell" && el.id > 0
                        )
                        .map((el) => el.date)[0]
                    )
                  : new Date()
              }
              buyTransactionID={
                userHoldingTransactions.state === "DONE"
                  ? userHoldingTransactions.data.getUserHoldingTransactions
                      .filter((el) => el.transactionType === "buy" && el.id > 0)
                      .map((el) => el.id)[0] ||
                    userHoldingTransactions.data.getUserHoldingTransactions
                      .filter(
                        (el) => el.transactionType === "no buy" && el.id < 0
                      )
                      .map((el) => el.id)[0]
                  : -1
              }*/
            />
          )}
        </div>

        {!user && (
          <div className="container">
            <StartEarningPerksCTA />
          </div>
        )}

        {props.howItWorks && props.contentSections?.sections && (
          <div
            id="HowItWorks"
            className={styles.howItWorksContainer}
            data-scroll-anchor
          >
            <HomeHowItWorks
              howItWorks={props.howItWorks}
              content={props.contentSections.sections[props.howItWorks.sys.id]}
              includes={props.pageSectionIncludes}
              joinNow={true}
            />
          </div>
        )}

        <div id="About" data-scroll-anchor ref={aboutSectionRef}>
          <BrandOverview
            brand={brand}
            company={props.iexCompany || undefined}
            includes={props.brandDetail?.includes}
          />
        </div>

        {brand && brand.files && (
          <BrandFiles
            downloadDescription={brand.filesDescription}
            tickerSymbol={brand.tickerSymbol}
            files={compact(
              brand.files.map((file) => {
                const parsedFile = getItemReference(
                  file,
                  props.brandDetail?.includes
                ) as Asset;

                if (!parsedFile) {
                  return undefined;
                }

                return {
                  title: parsedFile.fields.title,
                  description: parsedFile.fields.description,
                  url: parsedFile.fields.file.url,
                  fileName: parsedFile.fields.file.fileName,
                };
              })
            )}
          />
        )}

        {!brand ||
          (brand.showBottomAd && (
            <div className="container">
              <div className={styles.fullAdWrapper}>
                <Media greaterThanOrEqual="md">
                  <AdCampaign
                    size="brand-leaderboard"
                    keywords={[props.symbol]}
                  />
                </Media>
                <Media lessThan="md">
                  <AdCampaign
                    size="brand-half-page"
                    keywords={[props.symbol]}
                  />
                </Media>
              </div>
            </div>
          ))}

        {user && (
          <LifestyleQuestions userId={user.id} tickerSymbol={props.symbol} />
        )}

        {props.brandInsights && (
          <BrandInsights
            onViewMore={() => setInsightSidebarOpen(true)}
            tickerSymbol={props.symbol}
            loadedInsights={props.brandInsights}
          />
        )}

        <NoSSR>
          <Suspense fallback={<div>Loading...</div>}>
            {insightSidebarOpen && (
              <InsightsSidebar
                onSidebarClose={setInsightSidebarOpen}
                isOpen={insightSidebarOpen}
                tickerSymbol={props.symbol}
              />
            )}
          </Suspense>
        </NoSSR>

        <div id="News" data-scroll-anchor>
          <BrandNewsItems
            onViewMore={() => setNewsSidebarOpen(true)}
            tickerSymbol={props.symbol}
            includes={props.brandDetail?.includes}
            extractedPinnedNews={extractedPinnedNews.slice(0, 4)}
          />
        </div>

        {newsSidebarOpen && (
          <NewsSidebar
            onSidebarClose={setNewsSidebarOpen}
            isOpen={newsSidebarOpen}
            tickerSymbol={props.symbol}
            extractedPinnedNews={extractedPinnedNews}
            includes={props.brandDetail?.includes}
          />
        )}

        {!brand?.isNonPublicCompany && (
          <div id="Performance" data-scroll-anchor>
            <StockPerformance
              tickerSymbol={
                brand ? brand.iexSymbol ?? brand.tickerSymbol : props.symbol
              }
              quote={props.iexCompany ? props.iexCompany?.quote ?? null : null}
              showSidebarAd={brand ? brand.showSidebarAd : true}
              openTradeModal={() => setShowTradeModal(true)}
            />
          </div>
        )}

        {props.joinNowCTA && (
          <StartEarningPerksMadi
            page={props.joinNowCTA}
            includes={props.contentSections?.includes}
          />
        )}
      </div>
      <FooterV2 />
    </>
  );
};

export const defaultBrandTab = TabKey.Perks;

export default BrandDetailUI;
